import React from 'react';
import MapArticle from './MapArticle';
import Map from './Map';
import styled from 'styled-components';
import { device } from '../../styles/size';

const Story = styled.section`
  position: relative;
`;

const MapGraphics = styled(Map)`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1;

  height: 100vh;
  margin: 0;

  @media ${device.tablet} {
    background-color: white;
    height: 50vh;
  }
`;

const Regulation = () => {
  return (
    <Story>
      <MapGraphics />
      <MapArticle />
    </Story>
  );
};

export default Regulation;
